import React from 'react';

import { useInternationalization } from '@progress/kendo-react-intl';

import { IDocumentsCell } from '../../../types/IDocumentsCell';

import LoadingCell from '../../../../ui/table/cells/loadingCell/loadingCell';

import './dateCell.scss';

const DateCell: React.FC<IDocumentsCell> = ({ rowType, dataItem, field, treelist, style, className }) => {
  if (rowType === 'groupHeader') {
    return null;
  }

  if (dataItem[field] === undefined && treelist) return <td style={style} className={className} />;
  if (dataItem[field] === undefined) return <LoadingCell />;

  const intl = useInternationalization();

  return (
    <td style={style} className={className}>
      <div className='date-cell'>{intl.formatDate(new Date(dataItem[field]), 'd')}</div>
    </td>
  );
};

export default DateCell;
